<template>

    <div class="input-coupon">
        <div class="input-coupon-body">
            <form @submit.prevent="getCoupon">
                <v-input placeholder="Coupon code (optional)" :model="code" @input="code = $event" />
            </form>
            <transition name="fade">
                <v-button v-if="code.length" size="xs" btn-style="secondary" :loading="loading" @click.native="getCoupon">Apply</v-button>
            </transition>
        </div>
        <transition name="fade">
            <div v-if="error || success" class="input-coupon-footer">
                <span class="text-danger" v-if="error">Invalid - {{ error }}</span>
                <span class="text-success" v-else-if="success">Valid - {{ success }}</span>
            </div>
        </transition>
    </div>

</template>

<style scoped lang="scss">

    .input-coupon {
        .input-coupon-body {
            position: relative;
            .btn {
                position: absolute;
                top: 10px;
                right: 10px;
            }
        }
        .input-coupon-footer {
            @include font-medium(12px);
            margin-top: 10px;
        }
    }

</style>

<script>

import BillingApi from '@api/BillingApi';

export default {

    data() {
        return {
            loading: false,
            error: null,
            success: null,
            code: '',
        }
    },

    watch: {

        code(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.error = null;
                this.success = null;
            }
        },

    },

    methods: {

        getCoupon() {
            if (!this.code.length) return;
            this.loading = true;
            BillingApi.getCoupon(this.code)
                .then((response) => {
                    this.loading = false;
                    this.error = null;
                    this.success = response.data.data.coupon.name;
                    this.$emit('input', response.data.data.id);
                }, (error) => {
                    this.loading = false;
                    this.error = error.response.data.message;
                    this.success = null;
                });
        },

    },

}

</script>